import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { Notification as CoreNotification } from '@vds-core/notifications';
import { BodyConfig, TypographyConfig, Body, TitleConfig } from '@vds/typography';
import { colors } from '@vds/theme';
import { IconData } from '@vds/icons';
import { ButtonGroup } from '@vds/buttons';
var propTypes = {
  /**
   * Renders the provided title in VDS Body Large bold, not to be used with children.
   */
  title: PropTypes.string,

  /**
   * Renders the provided text in VDS Body Large below the title, not to be used with children.
   */
  subtitle: PropTypes.string,

  /**
   * If true, turns off maxWidth so that the container goes full width on viewport
   */
  fullBleed: PropTypes.bool,

  /**
   * Accepts an array of objects that allows buttons to be added to the notification.
   */
  buttonData: PropTypes.arrayOf(PropTypes.shape({
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    onClick: PropTypes.func,
    href: PropTypes.string
  })),

  /**
   * If true it will inset the notification when used in a container to align with the grid
   */
  inlineTreatment: PropTypes.bool,

  /**
   * Determines the orientation of buttons and text in the Notification.
   * @note Use of this prop overrides the default responsiveness to viewport.
   */
  layout: PropTypes.oneOf(['horizontal', 'vertical'])
};
var defaultProps = {
  fullBleed: false,
  inlineTreatment: false
};

var _animateIn = function _animateIn(containerHeight) {
  return keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(-", "px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n"])), containerHeight);
};

var _animateOut = function _animateOut(containerHeight) {
  return keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(-", "px);\n    opacity: 0;\n  }\n"])), containerHeight);
};

var Notification = function Notification(props) {
  var fullBleed = props.fullBleed,
      title = props.title,
      subtitle = props.subtitle,
      buttonData = props.buttonData;

  function _calculateContentColor(alertType, type, color) {
    if (alertType === 'warning' || type === 'warning' || alertType === 'error' || type === 'error') {
      return colors.black;
    } else {
      return colors.white;
    }
  }

  var animProperties = '0.35s cubic-bezier(0.22, 0.61, 0.36, 1) 0s normal 1 both';
  return /*#__PURE__*/React.createElement(CoreNotification, _extends({}, props, {
    hitArea: true,
    focusState: true,
    activeState: true,
    hasViewport: true,
    showNotificationIcon: true,
    minHeight: "52px",
    minWidth: '288px',
    maxWidth: '1272px',
    fullBleed: fullBleed,
    colorConfig: colors,
    title: title,
    subtitle: subtitle,
    iconConfig: IconData,
    bodyConfig: BodyConfig,
    animateIn: _animateIn,
    animateOut: _animateOut,
    closeButtonHeight: calculateRem(16),
    contentColor: _calculateContentColor,
    animationProperties: animProperties,
    unMountTime: 350,
    buttonData: buttonData,
    Body: Body,
    ButtonGroup: ButtonGroup,
    titleConfig: BodyConfig
  }));
};

Notification.propTypes = propTypes;
Notification.defaultProps = defaultProps;
export default Notification;